import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchDeleteList } from "../../redux";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { AgGridReact } from "ag-grid-react";
import style from "./RelatedPartiesDeleteEntries.module.css";
import { Link } from "react-router-dom";
import moment from "moment";
import { debounce } from 'lodash';
import ttmLodader from "../../assets/images/ttm-loader.gif";
import history from "../../utils/history";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

export class RelatedPartiesDeleteEntries extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      isDataFetched: false,
      deletedContactsList: []
    };
    //this.onSearchChange = debounce(this.onSearchChange.bind(this),1000);

    this.setLoader = this.setLoader.bind(this);
  }

  componentDidMount = async() => {
    document.title = 'Deleted Contacts - TechToMedix';
    await this.props.fetchDeleteList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );
    this.setState({
      deletedContactsList: this.props.partiesListData.deleteList.relatedParty
    })
    setTimeout(() => {
      if (this.props.partiesListData.deleteList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
      }
    }, 1000);
  }

  callDeletedContactsList = async() => {
    this.setState({
      deletedContactsList: [],
    });
    await this.props.fetchDeleteList(this.state.searchKey, this.state.sortBy, this.state.page);
    if(!this.props.partiesListData.loading){
      this.setState({
        deletedContactsList: this.props.partiesListData.deleteList.relatedParty
      })
      setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
      }, 1000);
    }
  }

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callDeletedContactsList();
    });
  };

  onSearchChange = (event) => {
    this.setState({ 
      searchKey: event.target.value, 
      page: 1, 
      isDataFetched: false 
    },()=>{
      this.callDeletedContactsList();
    });
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ 
      page, 
      isDataFetched: false 
    },()=>{
      this.callDeletedContactsList();
    });
  };

  typeFormatter(cell) {
    if (!cell) return "";
    return cell.charAt(0).toUpperCase() + cell.slice(1);
  }
  nameFormatter(cell, row){
    if (!cell && !row.surname) return "Not Available";
    return ((cell ? (cell.charAt(0).toUpperCase() + cell.slice(1)): "") + " " +
    (row.surname ? (row.surname.charAt(0).toUpperCase() + row.surname.slice(1)):""))
  }

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLodader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }

  goBack = () => {
    history.goBack();
  }

  render() {
    return (
      <div className={style.relatedPartiesListMainWarapper}>
        <div className="">
          <div className={style.relatedPartiesListMainWarapper}>
          {this.props.location.state && 
      this.props.location.state.fromNotifications === 1 &&  ( 
        <div className="mb-2">
            <span className="goBackBtn" onClick={this.goBack}>
              <i class="fa fa-arrow-left" aria-hidden="true"></i>{" "}
              Go Back to Notifications</span>
          </div>)}
            <div className="row">
              <div className="col-md-7">
                <h3>Deleted Contacts List</h3>
              </div>
              <div
                className={`col-md-5 order-3 order-md-2 d-flex justify-content-start justify-content-md-end`}
              >
               <div className="form-group">
                  <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search here"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />
                </div>
              </div>
            </div>
            <div className="row">
            <div class="col-md-12">
                <p>
                All the Contacts that have been deleted on the system and are pending Deletion Approval will be displayed here. 
                It is intended to show a track of all the Contacts that have been deleted on the system
                </p>
              </div>
            </div>
            <div className="row related-parties-delete-entries">
              <div className="col-md-12">
                <BootstrapTable
                  bordered={false}
                  data={this.state.deletedContactsList}
                  version="4"
                  search={false}
                  pagination
                  fetchInfo={{
                    dataTotalSize: this.props.partiesListData.deleteList.total,
                  }}
                  options={{
                    sortName: this.state.sortName,
                    sortOrder: this.state.sortOrder,
                    onSortChange: this.onSortChange,
                    onSearchChange: this.onSearchChange,
                    sizePerPage: 10,
                    page: this.state.page,
                    onPageChange: this.onPageChange,
                    noDataText: this.setLoader(),
                  }}
                >
                  <TableHeaderColumn
                    dataField="name"
                    isKey
                    width="25%"
                    dataSort={true}
                    dataFormat={(cell, row)=>this.nameFormatter(cell, row)}
                  >
                    Name
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="email"
                    width="25%"
                    dataSort={true}
                  >
                    Email
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="related_party_role"
                    width="25%"
                    dataSort={true}
                  >
                    Role
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="related_party_type"
                    width="25%"
                    dataSort={true}
                    dataFormat={this.typeFormatter}
                  >
                    Type
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="deleted_at"
                    width="25%"
                    dataSort={true}
                    dataFormat={dateFormatter}
                  >
                    Date
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    partiesListData: state.deletedPartiesList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDeleteList: (searchKey, sortBy, page) =>
      dispatch(fetchDeleteList(searchKey, sortBy, page)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RelatedPartiesDeleteEntries);
